import React from "react";
import { connect } from "react-redux";
import { setAuth, setI18N } from "../js/actions/index";

import { withRouter } from "react-router-dom";

import {
  Container,
  Col,
  Row,
  Button,
  Table,
  Form,
  Modal,
  ListGroup,
  DropdownButton,
  Dropdown
} from "react-bootstrap";

import {
  Basket,
  Box,
  ArrowLeftCircle,
  ExclamationCircle,
  XCircle,
  Pencil,
  Book,
  Binoculars,
} from "react-bootstrap-icons";

import moment from "moment";
import "moment-timezone";

import NavbarComponent from "../components/NavbarComponent";
import FooterComponent from '../components/FooterComponent';
import LoadingComponent from "../components/LoadingComponent";
import ServerErrorComponent from "../components/ServerErrorComponent";
import AuthErrorComponent from "../components/AuthErrorComponent";
import AlertErrorComponent from "../components/AlertErrorComponent";
import AlertSuccessComponent from "../components/AlertSuccessComponent";
import LogsModalComponent from "../components/LogsModalComponent";
import PurchaseOrderERPComponent from "../components/PurchaseOrderERPComponent";

import {
  formatUTC,
  formatCurrency,
  getSearchTermMatch,
  uint8ToBase64,
  dataURItoBlob,
  packagingUnitLabel,
  toFixed
} from "../js/global";

import FileSaver from "file-saver";

import { Formik } from "formik";
import * as Yup from "yup";

import { SingleDatePicker } from "react-dates";

import {
  SUCCESS,
  NO_USER_FOUND,
  FAILED_AUTHENTICATE_TOKEN,
} from "../constants/ApiResult";

import {
  PRODUCTS, UAT
} from "../constants/GlobalConstant";

// Services
import {
  addPurchaseOrderItemList,
  insertItemListInfo,
  setPurchaseOrderItemListWeigh,
  setPurchaseOrderItemList,
  setItemListInfo,
  setPurchaseOrderStorageDate,
  setPOState,
  postPO,
  putPurchaseOrderRemark,
  getPODetails,
  getItemListInfo
} from "../services/PurchaseOrder";

import {
  getInventoryBranchMapping,
  getSuppliersConfig,
  getSupplierInventory,
  getSupplierBranchCodeByBranchId,
  getTemporaryDeliveryLines
} from "../services/Supplier";

import {
  geti18nGoods
} from "../services/i18n";

import { EASYSOFT, MULTIABLE, SUPPLIER } from "../constants/GlobalConstant";

//import QRCode from "react-qr-code";

import I18N from "../js/i18n";
import {i18n} from "../js/global";

import { Can } from '../components/Can';

const services = {
  addPurchaseOrderItemList,
  insertItemListInfo,
  setPurchaseOrderItemListWeigh,
  setPurchaseOrderItemList,
  setItemListInfo,
  setPurchaseOrderStorageDate,
  setPOState,
  postPO,
  putPurchaseOrderRemark,
  getPODetails,
  getItemListInfo,
  getInventoryBranchMapping,
  getSuppliersConfig,
  getSupplierInventory,
  getSupplierBranchCodeByBranchId,
  geti18nGoods
};

//const cjson = require('compressed-json');

const utf8 = require("utf8");
const orientation = window.matchMedia("(max-width: 767px)").matches
  ? "vertical"
  : "horizontal";
/*
const schema = Yup.object({
  emailTo: Yup.string().email().required(),
  emailMessage: Yup.string().required(),
});
*/
const validationSchema = Yup.object().shape({
  emailTo: Yup.string()
    .required("*Email is required")
    .email("*Email is invalid"),
  emailMessage: Yup.string().required("*Message is required"),
});

const axios = require("axios").default;

const DECIMALS_2 = 2;
const DECIMALS_4 = 4;
const DECIMALS_5 = 5;
const DECIMALS_10 = 10;

function mapDispatchToProps(dispatch) {
  return {
    setAuth: (auth) => dispatch(setAuth(auth)),
    setI18N: (data) => dispatch(setI18N(data))
  };
}

class PurchaseOrder extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      addProductModalShow: false,
      addProductModalShowAttribute: false,
      advancedSearchProduct: true,
      advancedSearchSupplier: true,
      data: "",
      dataUI: "",
      dataInfo: "",
      dataUIInfo: "",
      dataProducts: "",
      dataDepartments: "",
      dataStorage: "",
      productSearchTerms: "",
      productsAdd: [],
      productsAddConfirm: [],
      emailModalShow: false,
      emailModalFormInvalid: true,
      emailModalProcessing: false,
      showAlertModal: false,
      alertModalConfig: {
        title: "",
        warning: "",
        function: "",
      },
      showUndoModal: false,
      isSavePurchaseOrder: false,
      poTouched: false,
      isLoading: true,
      authError: false,
      serverError: false,
      errorAPI: false,
      isPrint: false,
      saveSuccessful: false,
      confirmPOSuccessful: false,
      rejectPOSuccessful: false,
      addProductSuccessful: false,
      orderName: "",
      isEdit: false,
      supplierConfig: false,
      isLogs: false,
      branchCodeSupplier: "",
      erpData:[],
      i18n:{},
      inventoryBranchMapping:[],
      operatorId: "",
      sessionKey: "",
      deliveryLine:null,
      tempDeliveryLine:null
    };
  }

  componentDidMount = () => {
    if (window.location.pathname.indexOf("/purchase-order/share/") !== -1) {
      let id;
      if (this.props.id) {
        id = this.props.id;
      } else {
        id = this.props.match.params.id;
      }
      this.props
        .setAuth({
          mode: "supplier",
          isLogin: false,
          token: id,
          businessId: 0,
          operatorId: 0,
          supplierId: 0,
          isSupplier: true,
        })
        .then(() => {
          this.getPODetailsAPI();
          //this.getSuppliersConfig();
        });
    } else {
      this.getPODetailsAPI();
      //this.getSuppliersConfig();
    }

    this.updatePredicate();
    window.addEventListener("resize", this.updatePredicate);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updatePredicate);
  }

  /************************
  
MISC

************************/

  updatePredicate = () => {
    this.setState({
      isDesktop: window.innerWidth >= 768,
    });
  };

  isShareView = () => {
    if (this.props.readOnly) {
      return true;
    }
    return false;
  };

  isReadOnly = () => {
    if (
      this.props.readOnly ||
      (!this.props.readOnly &&
        this.state.data.State !== 1 &&
        !this.state.isEdit)
    ) {
      return true;
    }
    return false;
  };

  isPrint = () => {
    if (this.state.isPrint) {
      return true;
    }
    return false;
  };

  handleGoBack = () => {
    this.props.history.goBack();
  };

  /************************
  
API CALLS

************************/

  handleServerError = (err) => {
    this.setState(
      {
        isLoading: false,
        serverError: true,
      },
      () => {
        if (err) console.log(err);
      }
    );
  };

  handleErrorAPI = (err) => {
    this.setState(
      {
        isLoading: false,
        errorAPI: true,
      },
      () => {
        if (err) console.log(err);
      }
    );
  };

  handleAuthError = (err) => {
    this.setState(
      {
        isLoading: false,
        authError: true,
      },
      () => {
        if (err) console.log(err);
      }
    );
  };

// (GET) i18n Goods

geti18nGoods = () => {
  try {
    const props = {
      token: this.props.auth.token,
      supplierId: this.state.data.supplierId
    };
    return geti18nGoods(props);
  } catch (err) {
    this.handleServerError(err);
  }    
}

  /*
(GET) Inventory Branches Mapping
*/

  getInventoryBranchMapping = () => {
    try {
      const props = {
        token: this.props.auth.token,
        supplierId: this.state.data.supplierId,
      };
      const response = getInventoryBranchMapping(props);
      return response;
    } catch (err) {
      this.handleServerError(err);
    }
  };

    /*
(GET) Inventory Branches Mapping by Branch ONLY - reduces loading full supplier branch mappings by previous call
*/
  getInventoryBranchMapping2 = async () => {
    try {
      let branchCode = '';
      if (this.state.branchCodeSupplier) {
        branchCode = this.state.branchCodeSupplier;
      } else {
        branchCode = this.state.data.branchDetails.branchCode
      }
      const inventoryBranchMappings = await axios.get(`${process.env.REACT_APP_API_URL_MODEL}/api/getInventoryBranchMapping`, 
      {
          params:{
              branchCode: `${branchCode}`
          },
          headers: {
              operatorId:`${this.state.operatorId}`,
              branchid:`${this.state.data.branchDetails.BranchId}`,
              sessionkey:`${this.state.sessionKey}`,
              'Content-Type': 'application/json'
          }
      })
      console.log("INVENTORY BM: ", inventoryBranchMappings.data.data);
      console.log("DATA: ", this.state.data);

      const depMap = inventoryBranchMappings.data.data.findIndex( (obj) => obj.DepId === this.state.data.DepId);
      if ( depMap !== -1 ) {
        console.log("FOUND DEPARTMENT MAPPING - FILTERING BY DEPT!!")
        let filtered = inventoryBranchMappings.data.data.filter(
          (row) => row.DepId === this.state.data.DepId || row.DepId === 0
        );
        console.log("DATA FILTERED BY DEPT: ", filtered);
        return filtered;
      } else {
        console.log("NO DEPARTMENT MAPPING - SKIP DEPT FILTERING!!")
        return inventoryBranchMappings.data.data;
      }
    } catch (err) {
      this.handleServerError(err);
    };          
}

  /*
(GET) Supplier Inventory
*/

  getSupplierInventory = () => {
    try {
      const props = {
        token: this.props.auth.token,
        supplierId: this.state.data.supplierId,
        branchId: this.state.data.BranchId
      };
      const response = getSupplierInventory(props);
      return response;
    } catch (err) {
      this.handleServerError(err);
    }
  };

  /*
(GET) Suppliers Config
*/

  getSuppliersConfig = () => {
    try {
      const props = {
        token: this.props.auth.token,
        env: process.env.REACT_APP_ENV,
      };
      const response = getSuppliersConfig(props);
      return response;
    } catch (err) {
      this.handleServerError(err);
    }
  };

/*
(GET) Supplier Branch Code
*/

  getSupplierBranchCodeByBranchId = () => {
    try {
      const props = {
        token: this.props.auth.token,
        env: process.env.REACT_APP_ENV,
        supplierId: this.state.data.supplierId,
        branchId: this.state.data.BranchId
      };
      const response = getSupplierBranchCodeByBranchId(props);
      return response;
    } catch (err) {
      this.handleServerError(err);
    }
  }

  /*
(GET) PO Details
*/

  getPODetailsAPI = (callback) => {
    let id;
    if (this.props.id) {
      id = this.props.id;
    } else {
      id = this.props.match.params.id;
    }

    let apiArray = [
      getPODetails({
        token:this.props.auth.token,
        id:id
      }),
      getItemListInfo({
        token:this.props.auth.token,
        id:id
      })
    ];

    axios
      .all(apiArray)
      .then(
        axios.spread((data1, data2) => {
          if (
            typeof data1.data === "object" &&
            data1.data.POId &&
            typeof data2.data.data === "object"
          ) {
            axios
              .all([
                axios.get(
                  `${process.env.REACT_APP_API_URL}/api/getDepartment/${data1.data.BranchId}`,
                  {
                    headers: {
                      Authorization: "Basic " + this.props.auth.token,
                    },
                  }
                ),
                axios.get(
                  `${process.env.REACT_APP_API_URL}/api/getStorage/${data1.data.BranchId}`,
                  {
                    headers: {
                      Authorization: "Basic " + this.props.auth.token,
                    },
                  }
                ),
                axios.get(`${process.env.REACT_APP_API_URL}/api/getOperatorByBranchIdDepId/${data1.data.BranchId}/${data1.data.DepId}`, 
                {
                    params:{
                    },
                    headers: {
                        'Authorization': `Basic ${this.props.auth.token}`,
                    }
                }),        
              ])
              .then(
                axios.spread((data3, data4, data5) => {
                  if (
                    typeof data3.data === "object" &&
                    typeof data4.data === "object" &&
                    typeof data5.data === "object"
                  ) {
                    //if( typeof data1.data.POId !== 'undefined' ) {

                    let isLoading = false;
                    if(this.getSupplierConfig(data1.data.supplierId)) {
                      isLoading = true;
                    }
                    this.setState(
                      {
                        isLoading: isLoading,
                        data: data1.data,
                        dataUI: data1.data,
                        dataInfo: data2.data.data,
                        dataUIInfo: data2.data.data,
                        dataDepartments: data3.data.data,
                        dataStorage: data4.data.data,
                        operatorId: data5.data.data.OperatorId,
                        sessionKey: data5.data.data.SessionKey,
                        tempDeliveryLine: null
                      },
                      () => {

                        this.getTemporaryDeliveryLinesAPI()
                        console.log("data1.data.supplierId: ", data1.data.supplierId);
                        console.log("this.props.auth.mode: ", this.props.auth.mode);
                        console.log("this.props.auth.erp: ", this.props.auth.erp);

                        if(this.getSupplierConfig(data1.data.supplierId)) {
                          (async () => {
                            try {

                              if(this.props.auth.mode === SUPPLIER && this.props.auth.erp && Object.keys(this.props.auth.erp).length > 0) {
                                  let branchCodeSupplier = "";
                                  let deliveryLine = null;
                                  let response = await this.getSupplierBranchCodeByBranchId();
                                  let res = response.data.data;
                                  if(res.BranchCode) {
                                    branchCodeSupplier = res.BranchCode;
                                  }
                                  if(res.deliveryLine) {
                                    deliveryLine = res.deliveryLine;
                                  } else {
                                    deliveryLine = null;
                                  }

                                  this.setState({
                                    branchCodeSupplier:branchCodeSupplier,
                                    deliveryLine:deliveryLine
                                  });
                              }
                              let inventoryBranchMapping = await this.getInventoryBranchMapping2();
                              /*
                              // This call returns full supplier branch mappings and becomes inefficient for suppliers with large number of mappings

                              let response = await this.apiFactory("getInventoryBranchMapping", {
                                supplierId: this.state.data.supplierId
                              });

                              const inventoryBranchMapping = cjson.decompress(response.data.data);
                              */
                              const branchId = data1.data.branchDetails.BranchId;
                              
                              data1.data.purchaseOrderItemList.forEach( (item) => {
                                let filter = inventoryBranchMapping.filter( (obj) => obj.BranchId === branchId && obj.GoodsCode === item.GoodsCode )[0];
                                if(filter) {
                                  item.GoodsFormatName = filter.branchGoodsFormatName;
                                  item.GoodsFormatId = filter.goodsFormatId;
                                }
                              });

                              this.setState({
                                inventoryBranchMapping:inventoryBranchMapping,
                                isLoading:false
                              });
                            } catch(err) {
                              this.handleServerError(err);
                            }
                          })();
                        }
                        /*
                        if(this.props.auth.mode === SUPPLIER && this.props.auth.erp && Object.keys(this.props.auth.erp).length > 0) {
                          (async () => {
                            let branchCodeSupplier = "";
                            let response = await this.getSupplierBranchCodeByBranchId();
                            let res = response.data.data;
                            if(res.BranchCode) {
                              branchCodeSupplier = res.BranchCode;
                            }
                            this.setState({
                              branchCodeSupplier:branchCodeSupplier
                            });
                          })();
                        }
                        */
                        if (typeof callback === "function") {
                          callback();
                        }

                        // I18N temporary env condition
                        if(process.env.REACT_APP_ENV !== UAT) {
                          (async() => {
                            const i18nGoods = await this.geti18nGoods();
                            this.props.setI18N({
                              property:PRODUCTS,
                              value:i18nGoods.data.data
                            }).then( () => {
                              this.seti18n();
                            });
                          })(); 
                        } else {
                          this.seti18n();
                        }
                      }
                    );

                    //}
                  } else {
                    this.handleServerError();
                  }
                })
              )
              .catch((err) => {
                this.handleServerError(err);
              });
          } else {
            if (
              (data1.data.result || data2.data.result) === NO_USER_FOUND ||
              (data1.data.result || data2.data.result) ===
                FAILED_AUTHENTICATE_TOKEN
            ) {
              this.handleAuthError();
              return;
            }

            this.handleServerError();
          }
        })
      )
      .catch((err) => {
        this.handleServerError(err);
      });
  };

  /*
(GET) PO Data - Format
*/

  getPoData = () => {
    let data = this.state.data;

    // OrderName, GoodsName, Num, GoodsFormatName, salesPrice
    let itemList = [];
    let poTotal = 0;
    data.purchaseOrderItemList.forEach((item) => {
      itemList.push([
        { text: item.GoodsCode, alignment: "left" },
        { text: item.GoodsName, alignment: "left" },
        { text: item.Num, alignment: "right" },
        { text: item.GoodsFormatName, alignment: "right" },
        { text: formatCurrency(item.salesPrice), alignment: "right" },
        {
          text: formatCurrency(item.Num * item.salesPrice),
          alignment: "right",
        },
      ]);
      poTotal = poTotal + item.Num * item.salesPrice;
    });

    let dataObj = {
      branchDetails: {
        branchName: data.branchDetails.BranchName,
        address: data.branchDetails.Address,
        phone: data.branchDetails.PhoneNum,
        fax: data.branchDetails.fax,
      },
      businessDetails: {
        phoneNumber: data.businessDetails.PhoneNumber,
        email: data.businessDetails.Email,
        contactUser: data.businessDetails.ContactUser,
      },
      supplierDetails: {
        supplierName: data.supplierDetails.supplierName,
        address: data.supplierDetails.address,
        phone: data.supplierDetails.phone,
        email: data.supplierDetails.email.split(",")[0],
        contactPerson: data.supplierDetails.contactPerson,
      },
      orderName: data.OrderName,
      orderDate: formatUTC(this.state.data.CreateDate),
      deliveryDate: formatUTC(this.state.data.sureDate),
      remark: data.Remark,
      docDefBody: itemList,
      poTotal: formatCurrency(poTotal),
      poId: data.POId,
    };

    return dataObj;
  };

  /*
(GET) Download Purchase Order
*/

  handleDownloadPo = (po) => {
    this.setState(
      {
        isPrint: true,
      },
      () => {
        //let dataObj = this.getPoData();
        let html = utf8.encode(document.getElementById("root").innerHTML);

        this.setState(
          {
            isLoading: true,
            saveSuccessful: false,
            serverError: false,
            errorAPI: false,
          },
          () => {
            axios
              .request({
                responseType: "application/json",
                url: process.env.REACT_APP_API_URL_PDF,
                method: "get",
                params: {
                  html: html,
                },
                headers: {
                  Accept: "application/pdf",
                },
              })
              .then((response) => {
                (async () => {
                  //let base64 = await Buffer.from(response.data, 'base64');
                  const blob = dataURItoBlob(response.data);
                  this.setState(
                    {
                      isLoading: false,
                      isPrint: false,
                    },
                    () => {
                      FileSaver.saveAs(
                        new Blob([blob], { type: "application/pdf" }),
                        `${po}.pdf`
                      );
                    }
                  );
                })();
              })
              .catch((error) => {
                console.error(error.response);
                this.setState({
                  isLoading: false,
                  errorAPI: true,
                  isPrint: false,
                });
              });
          }
        );
      }
    );
  };

  /*
(POST) Email Purchase Order Send
*/

  handleEmailPoSend = (to, message, sendMe) => {
    if (sendMe) {
      to =
        to +
        "," +
        this.getSupplierEmail(this.getSupplierDetailsProperty("email"));
    }

    let dataObj = this.getPoData();

    axios
      .request({
        responseType: "arraybuffer",
        url: `${process.env.REACT_APP_API_URL}/api/pdfmake/po`,
        method: "post",
        data: {
          data: JSON.stringify(dataObj),
        },
        headers: {
          Accept: "application/pdf",
          Authorization: `Basic ${this.props.auth.token}`,
        },
      })
      .then((response) => {
        let base64String = uint8ToBase64(response.data);

        axios
          .request({
            url: `${process.env.REACT_APP_API_URL}/api/nodemailer`,
            method: "post",
            data: {
              orderName: this.state.data.OrderName,
              to: to,
              html: message,
              pdf: base64String,
            },
            headers: {
              Accept: "application/pdf",
              Authorization: `Basic ${this.props.auth.token}`,
            },
          })
          .then((response) => {
            this.handleCloseEmailModal();
          })
          .catch((err) => {
            this.handleServerError(err);
          });
      })
      .catch((err) => {
        this.handleServerError(err);
      });
  };

  /*
(GET) GoodsInfo List
*/

  handleOpenAddProductModal = () => {
    this.setState(
      {
        isLoading: true,
      },
      () => {
        (async () => {
          let supplierInventory = await this.getSupplierInventory();

          let dataProducts = supplierInventory.data.data;

          // is this supplier inventory required for branch mapping?
          if (!this.getSupplierConfig()) {
            // no mapping
            this.setAddProductModalData(dataProducts);
          } else {
            // yes mapping
            (async () => {
              if (this.state.inventoryBranchMapping.length) {
                let filtered = this.state.inventoryBranchMapping.filter(
                  (row) => {return (row.BranchId === this.state.data.BranchId)}
                );
                let dp = [];
                dataProducts.forEach((row) => {
                  const index = filtered.findIndex( (obj) => obj.GoodsCode === row.GoodsCode);
                  if ( index !== -1 ) {
                    let product = row;
                    product.goodsFormatList = product.goodsFormatList.filter( (goodsFormat) => {
                      return (goodsFormat.GoodsFormatName === filtered[index].branchGoodsFormatName) 
                    });

                    dp.push(product);
                    return true;
                  }
                  return false;
                });

                this.setAddProductModalData(dp);
              } else {
                this.setAddProductModalData(dataProducts);
              }
            })();
          }
        })();
      }
    );
  };

  /*
(State) Add Products Modal Data
*/

  setAddProductModalData = (dataProducts) => {

    this.setState({
      isLoading: false,
      dataProducts: dataProducts,
      addProductModalShow: true,
    });
  };

  /*
Handler Success (GET) Supplier Config
*/

  getSupplierConfig = (supplierId) => {
    if(!supplierId) {
      supplierId = this.state.data.supplierId;
    }

    let array = [];
    
    if(!Array.isArray(this.props.auth.suppliersConfig)) {
      array.push(this.props.auth.suppliersConfig);
    } else {
      array = this.props.auth.suppliersConfig;
    }
    
    if (typeof array[0] !== "undefined" && 
      array.findIndex( (obj) => obj.supplierId === supplierId && obj.poId ) > -1) {
      return true;
    }
    return false;
  };

  /*
(POST) Confirm Purchase Order
*/

  handleConfirmPO = () => {
    this.setState(
      {
        isLoading: true,
        saveSuccessful: false,
        serverError: false,
        errorAPI: false,
      },
      () => {
        axios
          .get(
            `${process.env.REACT_APP_API_URL}/api/getSessionKey/${this.state.data.OperatorId}`,
            {
              headers: {
                Authorization: "Basic " + this.props.auth.token, //the token is a variable which holds the token
              },
            }
          )
          .then((response) => {
            let sessionKey = response.data.data[0].sessionKey;

            if (sessionKey) {
              // success
              let goodsList = [];

              this.state.data.purchaseOrderItemList.forEach((good) => {
                goodsList.push({
                  goodsId: good.GoodsId,
                  num: good.Num,
                  goodsFormatId: good.GoodsFormatId,
                  sortVal: good.sortVal,
                  salesPrice: good.salesPrice,
                });
              });

              let params = {
                poId: this.state.data.POId,
                depId: this.state.data.DepId,
                storageId: this.state.data.StorageId,
                storageDate: this.state.data.StorageDate,
                remark: this.state.data.Remark,
                supplierId: this.state.data.supplierId,
                goodsList: goodsList,
              };

              axios
                .post(
                  process.env.REACT_APP_API_URL_ORDER,
                  {
                    query: `
                          mutation foo($poId:Int!, $depId:Int!, $storageId:Int!, $storageDate:String!, $remark:String!, $supplierId:Int!, $goodsList:[goodsListInput]) {
                            confirmOrder(poId:$poId, depId:$depId, storageId:$storageId, storageDate:$storageDate, remark:$remark, supplierId:$supplierId, goodsList:$goodsList) { 
                              responseCode
                              responseMsg
                              data {
                                orderName
                              }
                            }
                          }
                        `,
                    variables: {
                      poId: params.poId,
                      depId: params.depId,
                      storageId: params.storageId,
                      storageDate: params.storageDate,
                      remark: params.remark,
                      supplierId: params.supplierId,
                      goodsList: params.goodsList,
                    },
                  },
                  {
                    headers: {
                      branchid: this.state.data.BranchId,
                      sessionkey: sessionKey,
                      "Content-Type": "application/json",
                    },
                  }
                )
                .then((res) => {
                  let orderName = res.data.data.confirmOrder.data.orderName;
                  if (orderName) {
                    // success
                    this.setState({
                      isLoading: false,
                      confirmPOSuccessful: true,
                      orderName: orderName,
                    });
                  } else {
                    this.setState({
                      isLoading: false,
                    });
                  }
                })
                .catch((err) => {
                  this.handleServerError(err);
                });
            } else {
              this.handleErrorAPI();
            }
          })
          .catch((err) => {
            this.handleServerError(err);
          });
      }
    );
  };

  /*
(POST) Save Purchase Order
*/

  handleSaveConfirm = (callback) => {

    this.setState(
      {
        showAlertModal: false,
        isSavePurchaseOrder: false,
        addProductSuccessful: false,
        rejectPOSuccessful: false,
        isLoading: true,
        saveSuccessful: false,
        serverError: false,
        errorAPI: false,
      },
      () => {
        const remark = this.state.data.Remark;

        // IS WEIGH
        if (this.props.weighingList) {
          let items = [];
          this.state.dataUI.purchaseOrderItemList.forEach((item) => {
            if (item.UnitIdWeigh) {
              items.push({
                POIId: item.POIId,
                UnitIdWeigh: !item.UnitIdWeigh && item.UnitIdWeigh ? item.UnitIdWeigh : item.UnitIdWeigh,
                WeighNum: parseFloat(item.WeighNum, 2),
              });
            }
          });

          (async () => {
            await this.apiFactory("setPurchaseOrderItemListWeigh", {
              data: items,
            });

            await this.apiFactory("putPurchaseOrderRemark", {
              data: JSON.stringify({
                remark:remark,
                id:this.state.data.POId
              }),
            });

            // should make logging service more modular
            axios({
              method: "post",
              url: `${process.env.REACT_APP_API_URL_PO_LOGGING_POST}`,
              headers: {
                Authorization: "Basic " + this.props.auth.token,
              },
              data: {
                poAudit: {
                  poId: this.state.data.POId,
                  platform: 1,
                  mode: this.props.auth.mode === "supplier" ? 2 : 1,
                  operatorId:this.props.auth.operatorId,
                  operator:this.props.auth.operatorName,
                  action: 4,
                },
              },
            })
            .then((res) => {
              this.setState({
                isLoading: false,
                saveSuccessful: true,
              });
            })
            .catch((err) => {
              this.handleServerError(err);
            });

          })();
        } else {
          // structure is [[Num, POIId, DepId]]
          let dataUIInfo = [];
          let obj = JSON.parse(JSON.stringify(this.state.dataUIInfo));
          obj.forEach((obj) => {
            dataUIInfo.push([obj.Num, obj.POIId, obj.DepId]);
          });

/*
ERP Data
*/
          let erpData = [];
          if(this.state.data.State === 2) {
            if(this.props.auth.erp && Object.keys(this.props.auth.erp).length > 0) {
              switch(this.props.auth.erp.platform) {
                case MULTIABLE: {
                  if(this.props.auth.erp.api && this.props.auth.erp.api.put && this.props.auth.erp.api.put.purchaseOrder) {
                    this.state.dataUI.purchaseOrderItemList.forEach((row) => {
                      erpData.push({
                        "goodsCode":row.GoodsCode,
                        "goodsFormatName":row.GoodsFormatName,
                        "num":row.Num
                      });
                    });
                  }
                  break;
                }
                case EASYSOFT: {
                    if(this.props.auth.erp.api) {
                      this.state.dataUI.purchaseOrderItemList.forEach((row) => {
                        erpData.push({
                            "GoodsCode": row.GoodsCode,
                            "GoodsName": row.GoodsName,
                            "DeliveryNum": row.Num,
                            "GoodsFormatName": row.GoodsFormatName,
                            "salesPrice": row.salesPrice,
                            "WeighNum": 0,
                            "UnitIdWeigh": null
                        });
                    });
                    }
                  break
                }
                default: break;
              }
            }
          }

          axios
            .all([
            this.apiFactory("setPurchaseOrderItemList", {
              rnOrderId: this.state.data.rnOrderId,
              items: this.state.data.purchaseOrderItemList,
              itemsUI: this.state.dataUI.purchaseOrderItemList,
            }),
            this.apiFactory("setItemListInfo", {
              data: JSON.stringify(dataUIInfo),
            })
            ])
            .then(
              axios.spread((data1, data2) => {
                if (
                  data1.data.result === SUCCESS &&
                  data2.data.result === SUCCESS
                ) {
                  this.setState(
                    {
                      isLoading: false,
                      saveSuccessful: true,
                      poTouched: false,
                      data: this.state.dataUI,
                      dataInfo: this.state.dataUIInfo,
                      erpData:erpData
                    },
                    () => {

                      axios({
                        method: "post",
                        url: `${process.env.REACT_APP_API_URL_PO_LOGGING_POST}`,
                        headers: {
                          Authorization: "Basic " + this.props.auth.token,
                        },
                        data: {
                          poAudit: {
                            poId: this.state.data.POId,
                            platform: 1,
                            mode: this.props.auth.mode === "supplier" ? 2 : 1,
                            operatorId:this.props.auth.operatorId,
                            operator:this.props.auth.operatorName,
                            action: 4,
                          },
                        },
                      })
                      .then((res) => {
                        (async () => {
                            
                          await this.apiFactory("postPO", {
                            poId: this.state.data.POId,
                            cusPORef: this.state.dataUI.CusPORef
                          });

                          await this.apiFactory("putPurchaseOrderRemark", {
                            data: JSON.stringify({
                              remark:remark,
                              id:this.state.data.POId
                            }),
                          });

                          if (typeof callback === "function") {
                            callback();
                          }
  
                        })();
                      })
                      .catch((error) => {
                        this.handleServerError(error);
                      });

                    }
                  );
                } else {
                  this.handleErrorAPI();
                }
              })
            )
            .catch((err) => {
              this.handleServerError(err);
            });
        }
      }
    );
  };

  /*
(POST) Purchase Order Item List
*/

  apiFactory = (service, props) => {
    try {
      props.token = this.props.auth.token;
      const response = services[service](props);
      if (!response) {
        this.handleServerError();
      } else {
        return response;
      }
    } catch (err) {
      this.handleServerError(err);
    }
  };

  /*
(POST) Reject Purchase Order
*/

  handleRejectPO = () => {
    this.setState(
      {
        isLoading: true,
      },
      () => {
        (async () => {
          let response = await this.apiFactory("setPOState", {
            poId: this.state.data.POId,
            state: 4,
          });

          if (response.data.result === SUCCESS) {
            axios({
              method: "post",
              url: `${process.env.REACT_APP_API_URL_PO_LOGGING_POST}`,
              headers: {
                Authorization: "Basic " + this.props.auth.token,
              },
              data: {
                poAudit: {
                  poId: this.state.data.POId,
                  platform: 1,
                  mode: this.props.auth.mode === "supplier" ? 2 : 1,
                  operatorId:this.props.auth.operatorId,
                  operator:this.props.auth.operatorName,
                  action: 3,
                },
              },
            })
              .then((res) => {
                this.setState({
                  isLoading: false,
                  addProductSuccessful: false,
                  saveSuccessful: false,
                  rejectPOSuccessful: true,
                });
              })
              .catch((err) => {
                this.handleServerError(err);
              });
          }
        })();
      }
    );
  };

  /************************
  
ADD PRODUCT MODAL

************************/

  /*
Close
*/

  handleCloseAddProductModal = (success) => {
    let _success = false;
    if (typeof success === "boolean") {
      _success = success;
    }
    this.setState({
      addProductModalShow: false,
      addProductModalShowAttribute: false,
      productsAdd: [],
      addProductSuccessful: _success,
      rejectPOSuccessful: false,
      saveSuccessful: false,
    });
  };

  /*
Next
*/

  handleAddProductNext = () => {
    this.setState({
      addProductModalShowAttribute: true,
    });
  };

  /*
Confirm
*/

  handleAddProductConfirm = () => {
    this.setState(
      {
        isLoading: true,
      },
      () => {
        this.state.productsAdd.forEach((product) => {
          // POId, GoodsId, Num, Remark, State, GoodsFormatId, DeliveryNum, sortVal, salesPrice, maxNum
          let purchaseOrderItem = [
            [
              this.state.data.POId,
              product.goodsId,
              product.num,
              null,
              2,
              product.goodsFormatId,
              0,
              0,
              product.sellPrice,
              0,
            ],
          ];

          // does this goodsId, goodsFormatId exist?
          let purchaseOrderItemListIndex = this.isProductExist(
            product.goodsId,
            product.goodsFormatId
          );

          // product doesn't exists
          if (purchaseOrderItemListIndex === -1) {
            /*
(POST) Insert Purchase Order Item
*/
            (async () => {
              let receiptOrderItem = [];
              if (this.state.data.rnOrderId > 0) {
                receiptOrderItem = [
                  [
                    this.state.data.rnOrderId,
                    product.goodsId,
                    product.num, // To-do this should be more dynamic based on receipt state
                    2,
                    product.goodsFormatId,
                    product.num,
                    product.sellPrice,
                  ],
                ];
              }

              let response = await this.apiFactory("addPurchaseOrderItemList", {
                rnOrderId: this.state.data.rnOrderId,
                purchaseOrderItems: purchaseOrderItem,
                receiptOrderItems: receiptOrderItem,
              });

              /*
(POST) Insert Purchase Order Item Info
*/
              if (response) {
                (async () => {
                  await this.apiFactory("insertItemListInfo", {
                    insertItemListInfo: [
                      [
                        response.data.data.POIId,
                        this.state.data.POId,
                        parseFloat(product.num, 2),
                        this.state.data.DepId,
                        this.state.data.StorageId,
                      ],
                    ],
                  });
                  this.getPODetailsAPI(() =>
                    this.handleCloseAddProductModal(true)
                  );
                })();
              }
            })();
          }
        });
      }
    );
  };

  /*
Add Product List
*/

  htmlAddProductsList = () => {
    let html = this.state.dataProducts.map((row) => {
      return row.goodsFormatList.map((goodFormat, index) => {
        // only for main packaging (goodsFormatId === 0) or if supplier branch mapping
        if (goodFormat.GoodsFormatId === 0 || this.state.inventoryBranchMapping.length) {
          return this.filterProducts(
            row.GoodsCode,
            row.GoodsName,
            goodFormat,
            row.UnitName,
            index
          );
        } else return null;
      });
    });

    let isProducts = false;
    if (
      html.forEach((product) => {
        if (typeof product[0] === "object") {
          isProducts = true;
        }
      })
    );

    if (isProducts) {
      return (
        <>
        <Table bordered hover>
          <thead>
            <tr>
              <th>
                <Basket
                  size={16}
                  className="mb-1 me-1 d-none d-lg-inline d-xl-inline"
                />
                <I18N type="ui" path="PRODUCT_NAME" def="貨品名稱"/>
              </th>
              <th>
                <Box
                  size={16}
                  className="mb-1 me-1 d-none d-lg-inline d-xl-inline"
                />
                <I18N type="ui" path="PRODUCT_PACKAGING_UNIT" def="包裝單位"/>
              </th>
            </tr>
          </thead>
          <tbody>{html}</tbody>
        </Table>
        </>
      );
    } else {
      return (
        <ListGroup.Item className="text-info">
          <XCircle size={16} className="mb-1 me-1" />
          <I18N type="ui" path="NO_PRODUCTS_FOUND" def="No products found"/>
        </ListGroup.Item>
      );
    }
  };

  /*
Filter Products
*/

  filterProducts = (goodsCode, goodsName, item, unitName, index) => {
    // if product already exists in PO, don't show
    if (
      this.state.dataUI.purchaseOrderItemList.findIndex(
        (po) => po.GoodsId === item.GoodsId
      ) === -1
    ) {
      let supplierMatch = getSearchTermMatch(
        `${goodsCode}${goodsName}`,
        this.state.productSearchTerms
      );
      if (supplierMatch) {

        let label = goodsCode 
        ? <>
          <>({goodsCode}) </>
          <I18N 
          type={PRODUCTS}
          value={item.GoodsId} 
          def={goodsName} />
          </> 
        : goodsName;
      
        let html = (
          <tr key={`${item.GoodsId}-${index}`}>
            <td width="60%">
              <Form.Check
                type="checkbox"
                label={label}
                id={`add-product-${item.GoodsId}-${index}`}
                checked={
                  this.getAddProductIndex(item.GoodsId, item.GoodsFormatId) !==
                  -1
                    ? true
                    : false
                }
                onChange={(e) =>
                  this.handleClickSearchAddProduct(e, goodsName, item, unitName)
                }
              />
            </td>
            <td>
              {packagingUnitLabel(
                this.state.data.isShowPrice,
                item.Num,
                item.GoodsFormatName,
                unitName,
                item.SellPrice
              )}
            </td>
          </tr>
        );
        return html;
      } else {
        return false;
      }
    } else {
      return false;
    }
  };

  /*
(Return) Add Product
*/

  getAddProduct = (goodsId, goodsFormatId) => {
    return this.state.productsAdd.filter(
      (product) =>
        product.goodsId === goodsId && product.goodsFormatId === goodsFormatId
    )[0];
  };

  /*
(Return) Add Product Index
*/

  getAddProductIndex = (goodsId, goodsFormatId) => {
    return this.state.productsAdd.findIndex(
      (product) =>
        product.goodsId === goodsId && product.goodsFormatId === goodsFormatId
    );
  };

  /*
(State - Click) Search Add Product
*/

  handleClickSearchAddProduct = (e, goodsName, goodFormat, unitName) => {
    let arr = JSON.parse(JSON.stringify(this.state.productsAdd));
    let index = arr.findIndex(
      (item) =>
        item.goodsId === goodFormat.GoodsId &&
        item.goodsFormatId === goodFormat.GoodsFormatId
    );
    //schema, goodsId, goodsFormatId, num, depId, storageId
    if (e.currentTarget.checked) {
      // add
      if (index === -1) {
        arr.push({
          goodsName: goodsName,
          goodsId: goodFormat.GoodsId,
          goodsFormatId: goodFormat.GoodsFormatId,
          goodsFormatName: goodFormat.GoodsFormatName,
          goodsFormatNum: goodFormat.Num,
          num: 0,
          depId: this.state.data.DepId,
          storageId: this.state.data.StorageId,
          sellPrice: goodFormat.SellPrice,
          unitName: unitName,
        });
      }
    } else {
      // remove
      if (index !== -1) {
        arr.splice(index, 1);
      }
    }

    this.setState({
      productsAdd: arr,
    });
  };

  /*
(Change) Product Search Terms
*/

  handleChangeProductSearchTerms = (e) => {
    this.setState({
      productSearchTerms: e.currentTarget.value,
    });
  };

  /*
(Change) Add Product Quantity
*/

  handleChangeAddProductQuantity = (e, index) => {
    if (e.currentTarget.value >= 0) {
      let obj = JSON.parse(JSON.stringify(this.state.productsAdd));

      obj[index].num = e.currentTarget.value;

      this.setState({
        productsAdd: obj,
      });
    }
  };

  /*
(UI) Packaging Unit Label
*/

  htmlPackagingUnitLabel = (
    goodsFormatNum,
    goodsFormatName,
    unitName,
    unitPrice
  ) => {
    let label = `${goodsFormatName} ${
      this.state.data.isShowPrice && unitPrice > 0 ? ` HKD${unitPrice}` : ""
    }`;
    if (goodsFormatName !== unitName) {
      label = label + ` (1${goodsFormatName} = ${goodsFormatNum}${unitName})`;
    }
    return label;
  };

  /*
(UI) Add Product Attributes
*/

  htmlAddProductAttributes = () => {
    return this.state.productsAdd.map((row, index) => {
      let POIId = this.getProductPOIId(row.goodsId, row.goodsFormatId);
      let productInfo;
      if (POIId) {
        productInfo = this.getProductInfo(POIId);
        if (
          productInfo.findIndex((product) => product.POIId === POIId) === -1
        ) {
          productInfo = [
            {
              DepId: 0,
              StorageId: 0,
            },
          ];
        }
      }

      // Price
      let sellPrice = "";
      if (row.sellPrice > 0) {
        sellPrice = ` HKD ${formatCurrency(row.sellPrice)}`;
      }

      // Package, Price, Unit Label
      let packagingLabel = packagingUnitLabel(
        this.state.data.isShowPrice,
        row.goodsFormatNum,
        row.goodsFormatName,
        row.unitName,
        row.sellPrice
      );
      return (
        <div key={index} className="mt-2 mb-3 border-top">
          <div className="mt-2">
            <div>
              <span className="font-weight-bold text-secondary">
                {row.goodsName}
              </span>
            </div>
            <div>
              <span className="font-weight-light small">{packagingLabel}</span>
            </div>
          </div>
          <Row>
            <Col md={12} lg={4} className="mt-2">
              <Form.Label className="font-weight-bold text-end">
                數量
              </Form.Label>
              <Form.Control
                type="text"
                id={`text-num-${row.goodsId}-${row.goodsFormatId}`}
                value={row.num !== "" ? toFixed(row.num, DECIMALS_5) : ""}
                onChange={(e) => this.handleChangeAddProductQuantity(e, index)}
                size="sm"
                placeholder={0}
              />
            </Col>
          </Row>
        </div>
      );
    });
  };

  /************
DEPARTMENT
************/

  /*
(Return) Department Title
*/

  getDepartmentTitle = (depId) => {
    if (depId) {
      return this.state.dataDepartments.filter(
        (dep) => dep.DepId === parseInt(depId)
      )[0].DepName;
    }
    return "";
  };

  /*
(State) Product Add Property
*/

  setProductsAddProperty = (goodsId, goodsFormatId, property, value) => {
    let productsAdd = JSON.parse(JSON.stringify(this.state.productsAdd));
    let index = productsAdd.findIndex(
      (product) =>
        product.goodsId === goodsId && product.goodsFormatId === goodsFormatId
    );
    productsAdd[index][property] = value;
    this.setState({
      productsAdd: productsAdd,
    });
  };

  /*
(UI) Add Product
*/

  htmlAddProduct = () => {
    return (
      <Modal
        show={this.state.addProductModalShow}
        onHide={this.handleCloseAddProductModal}
        size="xl"
      >
        <Modal.Header closeButton>
          <Modal.Title><I18N type="ui" path="ADD_PRODUCT" def="Add Product"/></Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {!this.state.dataProducts ? (
            <LoadingComponent />
          ) : (
            !this.state.addProductModalShowAttribute && (
              <>
                <Form.Group controlId="formProductSearchText">
                  <Form.Label className="font-weight-bold text-primary">
                    <I18N type="ui" path="FILTER_PRODUCT" def="Filter Product"/>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    placeholder={this.state.i18n["PRODUCT_NAME"]}
                    value={this.state.productSearchTerms}
                    onChange={this.handleChangeProductSearchTerms}
                  />
                </Form.Group>
                <Form>
                  <ListGroup
                    className="mt-4"
                    style={{ maxHeight: 800, overflowY: "auto" }}
                  >
                    {this.htmlAddProductsList()}
                  </ListGroup>
                </Form>
              </>
            )
          )}

          {this.state.addProductModalShowAttribute && (
            <>
              <div className="float-end">
                <Button
                  variant="link"
                  className="px-0"
                  onClick={this.handleAddProductAttributesGoBack}
                >
                  <ArrowLeftCircle size={16} className="mb-1 me-1" /> <I18N type="ui" path="GO_BACK" def="Go Back"/>
                </Button>
              </div>
              <div className="mt-4">
                <span className="font-weight-bold text-primary">
                  <I18N type="ui" path="PRODUCT_ATTRIBUTES" def="Product Attributes"/>
                </span>
              </div>
              <div className="mt-2">{this.htmlAddProductAttributes()}</div>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={this.handleCloseAddProductModal}>
            <I18N type="ui" path="CLOSE" def="Close"/>
          </Button>
          {!this.state.addProductModalShowAttribute ? (
            <Button
              variant="primary"
              onClick={this.handleAddProductNext}
              disabled={this.state.productsAdd.length === 0 ? true : false}
            >
              <I18N type="ui" path="NEXT" def="Next"/>
            </Button>
          ) : (
            <Button
              variant="primary"
              disabled={this.addProductConfirmIsDisabled()}
              onClick={this.handleAddProductConfirm}
            >
              Confirm
            </Button>
          )}
        </Modal.Footer>
      </Modal>
    );
  };

  /*
(Boolean) Add Product Confirm Button Disabled State
*/

  addProductConfirmIsDisabled = () => {
    let disabled = false;
    this.state.productsAdd.forEach((product) => {
      if (parseFloat(product.num, 2) === 0) {
        disabled = true;
      }
    });
    return disabled;
  };

  /*
(State) Add Product Attributes - Go Back
*/

  handleAddProductAttributesGoBack = () => {
    this.setState({
      addProductModalShowAttribute: false,
    });
  };

  /************************
  
PURCHASE ORDER TABLE

************************/

  /*
(Change) Purchase Order Item List Quantity
*/

  handleChangePurchaseOrderItemListQuantity = (e, goodsId, goodsFormatId) => {
    //let num = parseInt(e.currentTarget.value);
    let num = e.currentTarget.value;
    //if( num >= 0 ) {
    let obj = JSON.parse(JSON.stringify(this.state.dataUI));

    // find the object with poIId
    let arrIndex = obj["purchaseOrderItemList"].findIndex(
      (obj) => obj.GoodsId === goodsId && obj.GoodsFormatId === goodsFormatId
    );

    if (arrIndex !== -1) {
      var tempArray = JSON.parse(JSON.stringify(obj["purchaseOrderItemList"]));
      tempArray[arrIndex].Num = num;

      let dataUI = Object.assign({}, this.state.dataUI, {
        purchaseOrderItemList: tempArray,
      });

      this.setState(
        {
          dataUI: dataUI,
          //isSavePurchaseOrder:true,
          poTouched: true,
        },
        () => {}
      );
    }
    //}
  };

  /*
(Change) Purchase Order Item List Sales Price
*/

  handleChangePurchaseOrderItemListSalesPrice = (e, goodsId, goodsFormatId) => {
    let salesPrice = e.currentTarget.value;

    if (salesPrice >= 0) {
      //let goodsId = parseInt(e.currentTarget.getAttribute('data-goodsid'));

      let obj = JSON.parse(JSON.stringify(this.state.dataUI));

      // find the object with poIId
      let arrIndex = obj["purchaseOrderItemList"].findIndex(
        (obj) => obj.GoodsId === goodsId && obj.GoodsFormatId === goodsFormatId
      );

      if (arrIndex !== -1) {
        var tempArray = JSON.parse(
          JSON.stringify(obj["purchaseOrderItemList"])
        );
        tempArray[arrIndex].salesPrice = salesPrice;

        let dataUI = Object.assign({}, this.state.dataUI, {
          purchaseOrderItemList: tempArray,
        });

        this.setState({
          dataUI: dataUI,
          //isSavePurchaseOrder:true,
          poTouched: true,
        });
      }
    }
  };

  /*
(Boolean) Product Exist
*/

  isProductExist = (goodsId, goodsFormatId) => {
    let index = this.state.data.purchaseOrderItemList.findIndex(
      (item) => item.GoodsId === goodsId && item.GoodsFormatId === goodsFormatId
    );
    return index;
  };

  /*
(Return) Product POIId
*/

  getProductPOIId = (goodsId, goodsFormatId) => {
    let index = this.state.data.purchaseOrderItemList.findIndex(
      (item) => item.GoodsId === goodsId && item.GoodsFormatId === goodsFormatId
    );
    if (index > -1) {
      return this.state.data.purchaseOrderItemList[index].POIId;
    }
  };

  /*
(Return) Product Info
*/

  getProductInfo = (poiid) => {
    if (this.state.dataInfo) {
      let dataInfo = this.state.dataInfo.filter((item) => item.POIId === poiid);
      return dataInfo;
    }
  };

  /*
(Return) Product UI Info
*/

  getProductUIInfo = (poiid) => {
    if (this.state.dataInfo) {
      let dataInfo = this.state.dataUIInfo.filter(
        (item) => item.POIId === poiid
      );
      return dataInfo;
    }
  };

  /*
(Return) Product Info Departments
*/

  getProductInfoDepartments = (productInfo) => {
    let arr = [];
    productInfo.forEach((obj) => {
      if (arr.indexOf(obj.DepId) === -1) {
        arr.push(obj.DepId);
      }
    });
    return arr;
  };

  /*
(Change) Product Number
*/

  handleChangeProductNum = (e, POIId, DepId) => {
    let num = e.currentTarget.value;
    if (num >= 0) {
      let dataUIInfo = JSON.parse(JSON.stringify(this.state.dataUIInfo));

      // find the object with poIId
      let arrIndex = dataUIInfo.findIndex(
        (obj) => obj.POIId === POIId && obj.DepId === DepId
      );

      if (arrIndex !== -1) {
        dataUIInfo[arrIndex].Num = num;

        let total = 0;
        dataUIInfo.forEach(
          (product) => (total = parseFloat(total) + parseFloat(product.Num))
        );

        // update the this.state.dataUI as well..
        let dataUI = JSON.parse(JSON.stringify(this.state.dataUI));
        let dataUIIndex = dataUI.purchaseOrderItemList.findIndex(
          (product) => product.POIId === POIId
        );

        if (dataUIIndex > -1) {
          dataUI.purchaseOrderItemList[dataUIIndex].Num = total;
        }

        this.setState({
          dataUI: dataUI,
          dataUIInfo: dataUIInfo,
          //isSavePurchaseOrder:true,
          poTouched: true,
        });
      }
    }
  };

  /*
(UI) Product Department Number
*/

  htmlProductDepartmentNum = (item, index) => {
    return (
      <Form.Control
        type="text"
        id={`text-num-${item.GoodsId}-${index}`}
        value={item.Num !== "" ? toFixed(item.Num, DECIMALS_5) : ""}
        placeholder={0}
        onChange={(value) =>
          this.handleChangePurchaseOrderItemListQuantity(
            value,
            item.GoodsId,
            item.GoodsFormatId
          )
        }
        size="sm"
      />
    );
  };

  /*
(Return) Purchase Order Item List Item Index
*/

  getPOItemListItemIndex = (goodsId, goodsFormatId) => {
    return this.state.dataUI.purchaseOrderItemList.findIndex(
      (obj) => obj.GoodsId === goodsId && obj.GoodsFormatId === goodsFormatId
    );
  };

  /*
(UI) Purchase Order Item List
*/

  htmlPurchaseOrderItemList = () => {
    let purchaseOrderItemList = JSON.parse(
      JSON.stringify(this.state.dataUI.purchaseOrderItemList)
    );

    const isItemWeigh = this.isItemWeigh();
    let html = purchaseOrderItemList.map((item, index) => {
      const metricTitle = this.getDropdownWeighMetricTitle(
        item.GoodsId,
        item.GoodsFormatId,
        item.UnitIdWeigh
      );
      
      return (
        <tr key={index}>
          <td>{item.GoodsCode}</td>
          <td>
            {<I18N
              type={PRODUCTS}
              value={item.GoodsId}
              def={item.GoodsName}
            />}
          </td>
          <td>
            {!this.isReadOnly()
              ? this.htmlProductDepartmentNum(item, index)
              : item.Num}
          </td>
          <td>
            {packagingUnitLabel(
              this.state.data.isShowPrice,
              item.GoodsFormatNum,
              item.GoodsFormatName,
              item.UnitName,
              null
            )}
          </td>
          {/*!this.props.weighingList &&
                    <td>
                        {
                            item.UnitName === item.GoodsFormatName
                            ?
                                ``
                            :
                                `${item.GoodsFormatNum} ${item.UnitName}/${item.GoodsFormatName}`
                        }
                    </td>
                    */}

          {this.props.weighingList === true ? (
            item.UnitIdWeigh && this.props.weighingList ? (
              <>
                <td>
                  <div className="no-print">
                    <Form.Control
                      type="text"
                      id={`text-weigh-metric-value-${item.GoodsId}-${index}`}
                      value={
                        item.WeighNum !== ""
                          ? toFixed(item.WeighNum, DECIMALS_4)
                          : ""
                      }
                      placeholder={0}
                      onChange={(e) =>
                        this.handleChangePurchaseOrderItemWeighNum(
                          e,
                          item.GoodsId,
                          item.GoodsFormatId
                        )
                      }
                      size="sm"
                    />
                  </div>
                  <div className="only-print">
                    {item.WeighNum > 0 ? toFixed(item.WeighNum, DECIMALS_2) : ""}
                  </div>
                </td>
                <td>
                  <div className="no-print">
                    <DropdownButton
                      id={`dropdown-weight-metric-${item.GoodsId}-${index}`}
                      variant="secondary"
                      title={metricTitle}
                      size="sm"
                      onSelect={(value) =>
                        this.handleOnSelectGoodsFormatWeigh(
                          value,
                          item.GoodsId,
                          item.GoodsFormatId
                        )
                      }
                    >
                      {/*<Dropdown.Item eventKey={0}></Dropdown.Item>*/}
                      {this.htmlDropdownWeightMetricOptions(metricTitle)}
                    </DropdownButton>
                  </div>
                  <div className="only-print">
                    {metricTitle}
                  </div>
                </td>
              </>
            ) : isItemWeigh ? (
              <>
                <td>
                  {this.getDropdownWeighMetricTitle(
                    item.GoodsId,
                    item.GoodsFormatId,
                    item.UnitIdWeigh
                  )}
                </td>
                <td>
                  {item.WeighNum > 0 ? toFixed(item.WeighNum, DECIMALS_2) : ""}
                </td>
              </>
            ) : (
              <></>
            )
          ) : (
            <></>
          )}

          {!this.props.weighingList && isItemWeigh && (
            <>
              <td>
                {item.WeighNum > 0 ? toFixed(item.WeighNum, DECIMALS_2) : ""}
              </td>
              <td>
                {this.getDropdownWeighMetricTitle(
                  item.GoodsId,
                  item.GoodsFormatId,
                  item.UnitIdWeigh
                )}
              </td>
            </>
          )}

          {!this.isReadOnly() ? (
            <td>
              <Form.Control
                type="text"
                id={`text-salesPrice-${item.GoodsId}-${index}`}
                value={
                  item.salesPrice !== "" ? toFixed(item.salesPrice, DECIMALS_10) : ""
                }
                placeholder={0}
                onChange={(e) =>
                  this.handleChangePurchaseOrderItemListSalesPrice(
                    e,
                    item.GoodsId,
                    item.GoodsFormatId
                  )
                }
                size="sm"
              />
            </td>
          ) : (
            this.isShowPrice() && (
              <td>{parseFloat(item.salesPrice).toFixed(DECIMALS_2)}</td>
            )
          )}

          {this.isShowPrice() && (
            <td>
              {isItemWeigh && item.WeighNum
              ?
                formatCurrency(item.WeighNum * item.salesPrice)
              :
                formatCurrency((!item.Num ? 0 : item.Num) * item.salesPrice)
              }
            </td>
          )}

        </tr>
      );
    });

    return <tbody>{html}</tbody>;
  };

  /************
WEIGHING
************/

  /*
(Return) Weight Metric/Value
*/

  isItemWeigh = () => {
    let isItemWeigh = false;
    this.state.dataUI.purchaseOrderItemList.forEach((row) => {
      if (row.UnitIdWeigh) {
        isItemWeigh = true;
      }
    });
    return isItemWeigh;
  };

  /*
(Select) Goods Format Weigh
*/

  handleOnSelectGoodsFormatWeigh = (value, goodsId, goodsFormatId) => {
    let index = this.getPOItemListItemIndex(goodsId, goodsFormatId);
    if (index > -1) {
      let dataUI = JSON.parse(JSON.stringify(this.state.dataUI));
      dataUI.purchaseOrderItemList[index].UnitIdWeigh = parseInt(value);
      this.setState({
        dataUI: dataUI,
      });
    }
  };

  /*
(Return) Dropdown Weigh Metric Title
*/

  getUnitsWeighing = () => {
    if(this.props.auth.units && this.props.auth.units.weighing) {
      return this.props.auth.units.weighing
    } else {
      return [];
    }
  }

  getUnitIdWeighLabel = (UnitId) => {
    let unit = this.getUnitsWeighing().filter(
      (row) => row.UnitId === UnitId
    )[0];
    if (typeof unit === "object") {
      return unit.UnitName;
    }
    return "";
  }

  getDropdownWeighMetricTitle = (goodsId, goodsFormatId, unitIdWeigh) => {
    // this.state.dataUI
    let index = this.getPOItemListItemIndex(goodsId, goodsFormatId);
    if (index > -1) {
      let UnitIdWeigh = this.state.dataUI.purchaseOrderItemList[index].UnitIdWeigh;
      if (UnitIdWeigh > 0) { 
        return this.getUnitIdWeighLabel(UnitIdWeigh);
      }
      if (this.getUnitsWeighing().length === 1) {
        if (
          this.state.dataUI.purchaseOrderItemList[index].UnitIdWeigh ===
          0
        ) {
          this.handleOnSelectGoodsFormatWeigh(
            this.getUnitsWeighing()[0].UnitId,
            goodsId,
            goodsFormatId
          );
        }
        return this.getUnitsWeighing()[0].UnitName;
      }
    }

    // set based on default UnitIdWeigh
    if(unitIdWeigh) {
      return this.getUnitIdWeighLabel(unitIdWeigh);
    }

    return "";
  };

  /*
(UI) Dropdown Weigh Metric Options
*/

  htmlDropdownWeightMetricOptions = (metricTitle) => {
    let data = this.getUnitsWeighing().filter( (obj) => obj.UnitName === metricTitle );
    return data.map((row, index) => {
      return (
        <Dropdown.Item eventKey={row.UnitId} key={index}>
          {row.UnitName}
        </Dropdown.Item>
      );
    });
  };

  /*
(Change) Purchase Order Item Weigh Number
*/

  handleChangePurchaseOrderItemWeighNum = (e, goodsId, goodsFormatId) => {
    if (e.currentTarget.value >= 0) {
      let index = this.getPOItemListItemIndex(goodsId, goodsFormatId);
      if (index > -1) {
        let dataUI = JSON.parse(JSON.stringify(this.state.dataUI));
        dataUI.purchaseOrderItemList[index].WeighNum = e.target.value;
        this.setState({
          dataUI: dataUI,
        });
      }
    }
  };

  /************************
 
EMAIL

************************/

  /*
(Close) Email Modal
*/

  handleCloseEmailModal = () => {
    this.setState({
      emailModalShow: false,
      emailModalProcessing: false,
    });
  };

  /*
(Open) Email Modal
*/

  handleOpenEmailModal = () => {
    this.setState({
      emailModalShow: true,
    });
  };

  /*
(Submit) Email
*/

  handleEmailSubmit = (values) => {
    this.setState(
      {
        emailModalProcessing: true,
      },
      () => {
        this.handleEmailPoSend(
          values.emailTo,
          values.emailMessage,
          values.emailSendMe
        );
      }
    );
  };

  /*
(Return) Supplier Email
*/

  getSupplierEmail = (email) => {
    if (email) return email.split(",")[0];
  };

  /*
(UI) Email Modal
*/

  htmlEmail = () => {
    let supplierEmail = this.getSupplierEmail(
      this.getSupplierDetailsProperty("email")
    );
    return (
      <Formik
        validationSchema={validationSchema}
        initialValues={{ emailTo: "", emailMessage: "", emailSendMe: false }}
        onSubmit={(values) => this.handleEmailSubmit(values)}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          isSubmitting,
        }) => (
          <Modal
            show={this.state.emailModalShow}
            onHide={this.handleCloseEmailModal}
          >
            <Modal.Header closeButton>
              <Modal.Title>Purchase Order - Email</Modal.Title>
            </Modal.Header>
            <Form noValidate onSubmit={handleSubmit}>
              <Modal.Body>
                {this.state.emailModalProcessing ? (
                  <LoadingComponent />
                ) : (
                  <>
                    <Form.Group controlId="formEmailTo">
                      <Form.Label>To</Form.Label>
                      <Form.Control
                        type="textbox"
                        name="emailTo"
                        placeholder="Enter to email address"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.emailTo}
                        isInvalid={touched.emailTo && errors.emailTo}
                        className={touched.v && errors.emailTo ? "error" : null}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.emailTo}
                      </Form.Control.Feedback>
                    </Form.Group>

                    {supplierEmail && (
                      <Form.Group controlId="formEmailSendMe">
                        <Form.Check
                          type={"checkbox"}
                          id="emailSendMe"
                          label={"Include me (" + supplierEmail + ")"}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.emailMessage}
                        />
                      </Form.Group>
                    )}

                    <Form.Group controlId="formEmailMessage">
                      <Form.Label>Message</Form.Label>
                      <Form.Control
                        as="textarea"
                        rows={3}
                        name="emailMessage"
                        placeholder=""
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.emailMessage}
                        isInvalid={touched.emailMessage && errors.emailMessage}
                        className={
                          touched.emailMessage && errors.emailMessage
                            ? "error"
                            : null
                        }
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.emailMessage}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </>
                )}
              </Modal.Body>
              <Modal.Footer>
                <Button
                  variant="secondary"
                  onClick={this.handleCloseEmailModal}
                >
                  Cancel
                </Button>
                <Button
                  variant="primary"
                  type="submit"
                  disabled={this.state.emailModalProcessing}
                >
                  Send
                </Button>
              </Modal.Footer>
            </Form>
          </Modal>
        )}
      </Formik>
    );
  };

  /************************
 
ALERT MODAL

************************/

  /*
(Save) Purchase Order
*/

  handleClickSavePurchaseOrder = () => {
    this.setState({
      showAlertModal: true,
      alertModalConfig: {
        title: this.props.weighingList ? <><I18N type="ui" path="WEIGHING_LIST" def="Weighing List"/> - <I18N type="ui" path="SAVE" def="Save"/></> : <><I18N type="ui" path="PURCHASE_ORDER" def="Purchase Order"/> - <I18N type="ui" path="SAVE" def="Save"/></>,
        warning:(<><I18N type="ui" path="SAVE_PURCHASE_ORDER" def="Save Purchase Order"/><>?</></>),
        function: this.handleSaveConfirm,
      },
    });
  };

  /*
(State) Alert Modal
*/

  handleToggleAlertModal = () => {
    this.setState({
      showAlertModal: !this.state.showAlertModal,
    });
  };

  /*
(UI) Alert Modal
*/

  htmlAlertModal = () => {
    return (
      <Modal
        show={this.state.showAlertModal}
        onHide={this.handleToggleAlertModal}
      >
        <Modal.Header closeButton>
          <Modal.Title>{this.state.alertModalConfig.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mt-4 text-center">
            <ExclamationCircle size={64} className="mb-1 me-1 text-warning" />
            <div>{this.state.alertModalConfig.warning}</div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={this.handleToggleAlertModal}>
          <I18N type="ui" path="CANCEL" def="Cancel"/>
          </Button>
          <Button
            variant="primary"
            onClick={this.state.alertModalConfig.function}
          >
            <I18N type="ui" path="CONFIRM" def="Confirm"/>
          </Button>
        </Modal.Footer>
      </Modal>
    );
  };

  /************************
 
UNDO MODAL

************************/

  /*
(State) Undo Modal
*/

  handleToggleUndoModal = () => {
    this.setState({
      showUndoModal: !this.state.showUndoModal,
    });
  };

  /*
(Method) Undo Modal
*/

  handleUndoChanges = () => {
    this.handleToggleUndoModal();
  };

  /*
(State) Undo
*/

  handleUndoChangesConfirm = () => {
    this.setState({
      dataUI: this.state.data,
      dataUIInfo: this.state.dataInfo,
      showUndoModal: false,
      poTouched: false,
      isSavePurchaseOrder: false,
    });
  };

  /*
(UI) Undo
*/

  htmlUndoChanges = () => {
    return (
      <Modal
        show={this.state.showUndoModal}
        onHide={this.handleToggleUndoModal}
      >
        <Modal.Header closeButton>
          <Modal.Title><><I18N type="ui" path="PURCHASE_ORDER" def="Purchase Order"/> - <I18N type="ui" path="UNDO_CHANGES" def="Undo Changes"/></></Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mt-4 text-center">
            <ExclamationCircle size={64} className="mb-1 me-1 text-warning" />
            <div><I18N type="ui" path="REVERT_PURCHASE_ORDER" def="Revert Purchase Order"/>?</div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={this.handleToggleUndoModal}>
            <I18N type="ui" path="CANCEL" def="Cancel"/>
          </Button>
          <Button variant="primary" onClick={this.handleUndoChangesConfirm}>
            <I18N type="ui" path="CONFIRM" def="Confirm"/>
          </Button>
        </Modal.Footer>
      </Modal>
    );
  };

  /*
(Click - State) Confirm Purchase Order
*/

  handleClickConfirmPurchaseOrder = () => {
    this.setState({
      showAlertModal: true,
      alertModalConfig: {
        title:(<><I18N type="ui" path="PURCHASE_ORDER" def="Purchase Order"/><> - </><I18N type="ui" path="CONFIRM" def="Confirm"/></>),
        warning:(<><I18N type="ui" path="CONFIRM_PURCHASE_ORDER" def="Confirm Purchase Order"/><>?</></>),
        function: () => this.handleSaveConfirm(this.handleConfirmPO),
      },
    });
  };

  /*
(Click - State) Reject Purchase Order
*/

  handleClickRejectPurchaseOrder = () => {
    this.setState({
      showAlertModal: true,
      alertModalConfig: {
        title:(<><I18N type="ui" path="PURCHASE_ORDER" def="Purchase Order"/><> - </><I18N type="ui" path="REJECT" def="Reject"/></>),
        warning:(<><I18N type="ui" path="REJECT_PURCHASE_ORDER" def="Reject Purchase Order"/><>?</></>),
        function: this.handleRejectPO,
      },
    });
  };

  /*
(Return) Supplier Details Property
*/

  getSupplierDetailsProperty = (prop) => {
    if (!this.state.data.supplierDetails) {
      return "";
    } else {
      return this.state.data.supplierDetails[prop];
    }
  };

  /*
(Return) Contact Name
*/

  getContactName = () => {
    return (
      <>
        <>
        {
          this.state.data.getOperator.Sex 
          ? 
          <I18N type="ui" path="MR" def="先生"/> 
          : 
          <I18N type="ui" path="MISS" def="小姐"/>
        }
        </>
        <>
          {" "}
        </>
        <>
          {`${this.state.data.getOperator.LastName}, ${this.state.data.getOperator.FirstName}`}
        </>
      </>
    )
  };

  /*
(Return) Purchase Order State Title
*/

  getPOStateTitle = () => {
    if (this.state.data.State === 1) {
      return (<><I18N type="ui" path="PENDING_APPROVAL" def="未經批准"/><> - </></>);
    } else if (this.state.data.State === 4) {
      return <I18N type="ui" path="REJECTED" def="拒絕了"/>;
    }
    return;
  };

  /*
(Return) Sub Total
*/

  htmlSubTotal = () => {
    let tally = 0;
    const isItemWeigh = this.isItemWeigh();
    this.state.dataUI.purchaseOrderItemList.forEach((item) => {
      let num = !item.Num ? 0 : item.Num;
      if(isItemWeigh && item.WeighNum) {
        num = item.WeighNum;
      }
      tally = tally + parseFloat((num * item.salesPrice).toFixed(DECIMALS_2));
    });
    return tally;
  };

  /*
(Return) Total
*/

  htmlTotal = () => {
    return this.htmlSubTotal();
  };

  /*
Single Date Picker (Delivery Date)
*/

  htmlSingleDatePicker = () => {
    return (
      <SingleDatePicker
        date={
        this.state.data.StorageDate.indexOf('T') > -1 ? 
            moment(this.state.data.StorageDate).utc(0) : 
            moment(this.state.data.StorageDate)
        }
        onDateChange={(date) => this.handleDeliveryDateChange(date)}
        focused={this.state.focused}
        onFocusChange={({ focused }) => this.setState({ focused })}
        id="deliveryDate"
        orientation={orientation}
        small={true}
        displayFormat="DD/MM/YYYY"
        isOutsideRange={(day) => {
          if(this.props.auth.ui.datepicker && this.props.auth.ui.datepicker.isOutsideRange) {
            return false;
        } else {
            if(moment(day).format('YYYY-MM-DD') === moment().format('YYYY-MM-DD')) {
                return false;
            }
            return (moment().diff(day) > 0);
        }
      }}
      />
    );
  };

  handleDeliveryDateChange = (date) => {
    let data = JSON.parse(JSON.stringify(this.state.data));
    data.StorageDate = `${moment(date).format("YYYY-MM-DD")} 00:00:00`;
    let dataUI = JSON.parse(JSON.stringify(this.state.dataUI));
    dataUI.StorageDate = `${moment(date).format("YYYY-MM-DD")} 00:00:00`;
    this.setState(
      {
        data: data,
        dataUI: dataUI
      },
      () => {
        (async () => {
          let response = await this.apiFactory("setPurchaseOrderStorageDate", {
            date: `${moment(date).format("YYYY-MM-DD")} 00:00:00`,
            poId: this.state.data.POId,
          });

          if (response.data.result === SUCCESS) {
            /*
            this.setState({
              saveSuccessful: true,
            });
            */
          }
        })();
      }
    );
  };

/*
ERP Delivery Date
*/

  getERPDeliveryDate = () => {
    switch(this.props.auth.erp.platform) {
      case EASYSOFT: {
        return moment(this.state.data.StorageDate).utc(0).format("YYYY-MM-DD");
      }
      case MULTIABLE: {
        return this.state.data.StorageDate;
      }
      default: {
        return this.state.data.StorageDate;
      }
    }

  }

/*
Customer Ref PO
*/

  handleOnChangeCusRefPO = (e) => {
    let cusPORef = e.target.value.substring(0,30);

    let dataUI = JSON.parse(JSON.stringify(this.state.dataUI));
    dataUI.CusPORef = cusPORef;

    this.setState({
        dataUI:dataUI
    });
  }

  /***
 Logs Modal
*/

  handleClickLogs = () => {
    this.setState({
      isLogs: !this.state.isLogs,
    });
  };

/*
Show Pricing
*/

  isShowPrice = () => {
    if(
      (this.props.packingList && !this.props.auth.ui.purchaseOrders.approved.packingListPrice) || 
      (!this.props.packingList && !this.state.data.isShowPrice)
    ) {
      return false;
    }
    return true;
  }

/*
Remark
*/

handleOnChangeRemark = (value) => {
  
  let data = JSON.parse(JSON.stringify(this.state.data));
  let dataUI = JSON.parse(JSON.stringify(this.state.dataUI));

  data.Remark = value;
  dataUI.Remark = value;
  
  this.setState({
    data:data,
    dataUI:dataUI
  });
}

/*
i18n
*/

seti18n = () => {
  [{
      type:'ui',
      path:'CUSTOMER_ORDER_NUMBER',
      def:'客戶訂單號碼'
  },{
    type:'ui',
    path:'PRODUCT_NAME',
    def:'貨品名稱'
  }].forEach( (obj) => {
      i18n(obj.type,obj.path,obj.def).then((value) => {
          let i18n = JSON.parse(JSON.stringify(this.state.i18n));
          if(value) {
            i18n[obj.path] = value;
          } else {
              i18n[obj.path] = obj.def;
          }     
          this.setState({
              i18n:i18n
          });
      });    
  });
}

// (GET) Temporary Delivery Lines
getTemporaryDeliveryLinesAPI = async () => {
  try {
      const props = {
          supplierId: this.props.auth.supplierId,
          date: moment(this.state.dataUI.StorageDate).format('YYYY-MM-DD'),
          token: this.props.auth.token
      };
      
      let res = await getTemporaryDeliveryLines(props);
      let data = res.data.data;

      this.handleResponseAPI(res.data.result);

      const foundObj = data.find(obj => obj.branchId === this.state.data.BranchId);
      if (foundObj) {
          console.log(`Setting temporary delivery line from ${this.state.deliveryLine} to ${foundObj.tempDeliveryLine}`)
          this.setState({
            tempDeliveryLine: foundObj.tempDeliveryLine
          });
      }
  } catch (err) {
      console.log(err);
  }
}

handleResponseAPI = (data) => {
  if (
      [NO_USER_FOUND, FAILED_AUTHENTICATE_TOKEN].indexOf(
        data
      ) > -1
    ) {
      this.setState({
        isLoading: false,
        authError: true,
      });
      return;
    }
}

handleServerErrorAPI = (err) => {
  this.setState(
    {
      isLoading: false,
      serverError: true,
    },
    () => {
      if (err) console.log(err);
    }
  );
};
/* 
NavbarComponent onClick Callback
*/

onClickNavBarLocale =  () => {
  this.seti18n();
}


  /************************
 
RENDER

************************/

  render() {
    /*
        if(this.props.weighingList && !this.state.data.isWeigh) {
            return false;
        }
        */

    return (
      <>
        <Container fluid className="p-0 mb-5">
          {!this.isShareView() && !this.isPrint() && <NavbarComponent 
            onClickLocale={this.onClickNavBarLocale}
          />}
          <Container className="print-layout portrait-section">
            {this.state.authError || this.state.serverError ? (
              <Row className="mt-4">
                <Col xs={12}>
                  <>
                    {!this.props.weighingList && <h1><I18N type="ui" path="PURCHASE_ORDER" def="Purchase Order"/></h1>}
                    {this.state.authError && <AuthErrorComponent />}
                    {this.state.serverError && <ServerErrorComponent />}
                  </>
                </Col>
              </Row>
            ) : this.state.isLoading ? (
              <LoadingComponent />
            ) : this.props.weighingList && !this.state.data.isWeigh ? (
              <></>
            ) : (
              <>
                {!this.isShareView() && !this.isPrint() && (
                  <Row className="mt-4 no-print">
                    <Col xs={12} className="text-end">
                      <Button
                        variant="link"
                        className="px-0 me-4"
                        onClick={this.handleGoBack}
                      >
                        <ArrowLeftCircle size={16} className="mb-1 me-1" /> <I18N type="ui" path="GO_BACK" def="Go Back"/>
                      </Button>

                      {this.state.data.State !== 4 && !this.state.rejectPOSuccessful &&
                      <Can I="edit" a="PurchaseOrder">
                        <Button
                          variant="link"
                          className="px-0 me-4"
                          onClick={() =>
                            this.setState({ isEdit: !this.state.isEdit, saveSuccessful: false,  erpError:false, erpSuccess:false})
                          }
                        >
                          {!this.state.isEdit ? (
                            <>
                              <Pencil size={16} className="mb-1 me-1" /> <I18N type="ui" path="EDIT" def="Edit"/>
                            </>
                          ) : (
                            <>
                              <Book size={16} className="mb-1 me-1" /> <I18N type="ui" path="READ_ONLY" def="Read Only"/>
                            </>
                          )}
                        </Button>
                      </Can>
                      }

                      <Button
                        variant="link"
                        className="px-0 me-2"
                        onClick={() => this.handleClickLogs()}
                      >
                        <Binoculars size={16} className="mb-1 me-1" /> <I18N type="ui" path="LOGS" def="Logs"/>
                      </Button>
                      {/*
                        <Button variant="link" className="px-0 me-4" disabled={this.state.isSavePurchaseOrder} onClick={ () => this.handleDownloadPo(this.state.data.OrderName)}><Download size={16} className="mb-1 me-1" />Download (PDF)</Button>   
                        <Button variant="link" className="px-0" disabled={this.state.isSavePurchaseOrder} onClick={this.handleOpenEmailModal}><Envelope size={16} className="mb-1 me-1" />Email</Button>
                      */}
                    </Col>
                  </Row>
                )}
                <Row>
                  {this.props.packingList && !this.props.weighingList
                  ?
                    <></>
                  :
                    <>
                      <Col sm={8}>
                        <div className="font-weight-bold mb-1">
                          {this.state.data.branchDetails.BranchName}
                        </div>
                      </Col>
                      <Col sm={4} className="text-end justify-content-end">
                        {!this.props.weighingList &&
                        <div>
                          <h4 className="d-inline-block text-primary mt-2 border-bottom border-primary">
                          {this.getPOStateTitle()}<I18N type="ui" path="PURCHASE_ORDER" def="採購單"/>
                          </h4>
                        </div>
                        }
                        <div className="font-weight-bold">
                          <div><I18N type="ui" path="PURCHASE_ORDER_NUMBER" def="採購單號"/>: {`${this.state.data.OrderName}`}</div>
                          <div className="mt-1">
                            <span className="me-2"><I18N type="ui" path="ORDER_DATE" def="採購日期"/>:</span>
                            {moment(this.state.data.CreateDate).utc(0).format(
                              "D MMM YYYY"
                            )}
                          </div>
                          <div className="mt-1">
                            <span className="me-2"><I18N type="ui" path="DELIVERY_DATE" def="送貨日期"/>:</span>
                            {!this.state.isEdit || this.state.rejectPOSuccessful
                              ? 
                              moment(this.state.data.StorageDate).utc(0).format("D MMM YYYY")
                              : 
                              <div>
                              {this.htmlSingleDatePicker()}
                              </div>
                            }
                          </div>
                          <div className="mt-1">
                            {(this.state.dataUI.CusPORef || this.state.isEdit) && <span className="me-2"><I18N type="ui" path="CUSTOMER_ORDER_NUMBER" def="客戶訂單號碼"/>:</span>}
                            
                            {!this.state.isEdit || this.state.rejectPOSuccessful
                              ?
                              this.state.dataUI.CusPORef
                              : 
                              <>
                                <Form.Group 
                                controlId="formCusPORef"
                                >
                                  <Form.Control 
                                      type="text" 
                                      placeholder={this.state.i18n["CUSTOMER_ORDER_NUMBER"]}
                                      onChange={this.handleOnChangeCusRefPO} 
                                      value={this.state.dataUI.CusPORef ? this.state.dataUI.CusPORef : ""}
                                  />
                                </Form.Group>
                              </>
                             

                            }
                          </div>
                          {!this.props.weighingList && <div className="mt-1"><I18N type="ui" path="CURRENCY" def="貨幣"/>: <I18N type="ui" path="HKD" def="港元"/></div>}
                        </div>
                      </Col>
                    </>
                  }

                  {!this.isPrint() &&
                    !this.state.confirmPOSuccessful &&
                    !this.state.rejectPOSuccessful && (
                      <Col xs={12} sm={6} className="text-end">
                        {/*<Button variant="link" className="px-0" disabled={this.state.isSavePurchaseOrder} onClick={ () => this.handleDownloadPo(this.state.data.OrderName)}><Download size={16} className="mb-1 me-1" />Download (PDF)</Button>*/}
                        {/*<Button variant="link" className="px-0 ms-3" disabled={this.state.isSavePurchaseOrder} onClick={this.handleOpenEmailModal}><Envelope size={16} className="mb-1 me-1" />Email</Button>*/}

                        {/*
                                        <div>
                                            <Button
                                                variant="link"
                                                className="px-0 text-warning"
                                                onClick={ () => document.getElementById("btnSavePurchaseOrder").focus()}>
                                                    <ExclamationCircle size={16} className="mb-1 me-1" />
                                                    Save Purchase Order
                                            </Button>
                                        </div>
                                        */}
                      </Col>
                    )}
                </Row>
                <Row className="mt-4 no-print">
                  <Col xs={12}>
                    {this.state.saveSuccessful && (
                      <>
                      <AlertSuccessComponent label={
                        <I18N type="ui" path="SAVE_PURCHASE_ORDER_SUCCESSFUL" def="Save Purchase Order Successful"/>
                      } />
                              {this.state.erpError &&
                                <AlertErrorComponent
                                  label="Purchase Order ERP push error"
                                />
                              }
                              {this.state.erpSuccess &&
                                <AlertSuccessComponent
                                  label="Purchase Order ERP push successful"
                                />
                              }

                      {this.props.auth.erp && Object.keys(this.props.auth.erp).length > 0 && this.state.erpData.length > 0 &&
                        <PurchaseOrderERPComponent
                          deliveryLine={this.state.tempDeliveryLine ? this.state.tempDeliveryLine : this.state.deliveryLine}
                          orderName={this.state.data.OrderName}
                          cusPORef={this.state.dataUI.CusPORef}
                          branchCode={this.state.branchCodeSupplier}
                          branchName={this.state.data.branchDetails.BranchName}
                          depName={this.getDepartmentTitle(this.state.data.DepId)}
                          data={this.state.erpData}
                          deliveryDate={this.getERPDeliveryDate()}
                          remark={this.state.data.Remark}
                          state={2}
                          visible={false}
                          mode="push"
                          onError={ () => {
                            this.setState({
                                erpError:true
                            })
                          }}
                          onSuccess={ () => {
                            this.setState({
                                erpSuccess:true
                            })
                          }}

                        />   
                      }
                      </>
                    )}
                    {this.state.addProductSuccessful && (
                      <AlertSuccessComponent label={
                        <I18N type="ui" path="ADD_PRODUCT_SUCCESSFUL" def="Add Product Successful"/>
                      } />
                    )}
                    {this.state.confirmPOSuccessful && (
                      <AlertSuccessComponent
                        label={
                          <>
                            <I18N type="ui" path="CONFIRM_PURCHASE_ORDER_SUCCESSFUL" def="Confirm Purchase Order Successful"/>: 
                            {" "}
                            {this.state.orderName}
                          </>
                        }
                      />
                    )}
                    {this.state.rejectPOSuccessful && (
                      <>
                      <AlertSuccessComponent
                        label={
                          <>
                            <I18N type="ui" path="REJECT_PURCHASE_ORDER_SUCCESSFUL" def="Reject Purchase Order Successful"/>: 
                            {" "}
                            {this.state.data.OrderName}
                          </>
                        }
                      />
                      {(this.props.auth.erp.api && this.props.auth.erp.api.delete) &&
                        <PurchaseOrderERPComponent
                          orderName={this.state.data.OrderName}
                          branchCode={this.state.branchCodeSupplier}
                          data={this.state.erpData}
                          deliveryDate={this.state.data.StorageDate}
                          visible={false}
                          mode="delete"
                        />
                      }
                      
                      {(this.props.auth.erp && this.props.auth.erp.platform === EASYSOFT) &&
                        <PurchaseOrderERPComponent
                          orderName={this.state.data.OrderName}
                          cusPORef={this.state.dataUI.CusPORef}
                          branchCode={this.state.branchCodeSupplier}
                          branchName={this.state.data.branchDetails.BranchName}
                          depName={this.getDepartmentTitle(this.state.data.DepId)}
                          data={this.state.erpData}
                          deliveryDate={moment(this.state.data.StorageDate).utc(0).format("YYYY-MM-DD")}
                          remark={this.state.data.Remark}
                          state={4}
                          visible={false}
                          mode="push"
                        />                      
                      }
                      </>
                    )}
                    {this.state.errorAPI && (
                      <AlertErrorComponent label={<I18N type="ui" path="BAD_REQUEST_400" def="Bad Request (400)"/>} />
                    )}
                  </Col>
                </Row>
                {!this.state.confirmPOSuccessful &&
                  !this.state.rejectPOSuccessful && (
                    <>
                      <Row>
                        <Col xs={12} sm={4} className="my-4 col-4-print">
                          <div>
                            <h5 className="text-primary mb-2"><I18N type="ui" path="SUPPLIER" def="供應商"/></h5>
                          </div>
                          <div className="font-weight-bold mb-1">
                            {this.getSupplierDetailsProperty("supplierName")}
                          </div>
                          <div>
                            {this.getSupplierDetailsProperty("address")}
                          </div>

                          {this.getSupplierDetailsProperty("phone") && (
                            <div>
                              <I18N type="ui" path="PHONE" def="電話"/>: {""}
                              {this.getSupplierDetailsProperty("phone")}
                            </div>
                          )}

                          {this.getSupplierDetailsProperty("fax") && (
                            <div>
                              <I18N type="ui" path="FAX" def="傳真"/>: {""}
                              {this.getSupplierDetailsProperty("fax")}
                            </div>
                          )}

                          {this.getSupplierDetailsProperty("email") && (
                            <div>
                              <I18N type="ui" path="EMAIL" def="電郵"/>: {""}
                              <span className="text-break">
                                {this.getSupplierDetailsProperty("email")}
                              </span>
                            </div>
                          )}
                        </Col>
                        <Col xs={12} sm={4} className="mt-4 col-4-print">
                          <div>
                            <h5 className="text-primary mb-2"><I18N type="ui" path="DELIVERY_ADDRESS" def="送貨地址"/></h5>
                          </div>
                          <div className="font-weight-bold mb-1">
                            {this.state.data.branchDetails.BranchName}
                          </div>
                          <div>{this.state.data.branchDetails.Address}</div>
                          <div>
                            <I18N type="ui" path="DEPARTMENT" def="部門"/>:{" "}
                            {this.getDepartmentTitle(this.state.data.DepId)}
                          </div>
                          <div><I18N type="ui" path="CONTACT_PERSON" def="聯絡人"/>: {this.getContactName()}</div>
                          {this.state.data.getOperator.Mobile && (
                            <div>
                              <I18N type="ui" path="PHONE" def="電話"/>: {this.state.data.getOperator.Mobile}
                            </div>
                          )}
                        </Col>
                        <Col xs={12} sm={4} className="mt-4 col-4-print">
                          <h5 className="text-primary mb-2"><I18N type="ui" path="INVOICE" def="發票"/></h5>
                          <div>發票寄至財務部應付賬款</div>
                          {this.state.data.businessDetails.businessAddr}
                        </Col>
                      </Row>

                      {!this.isReadOnly() && (
                        <Row className="mt-4">
                          <Col xs={6}>
                            <Button onClick={this.handleOpenAddProductModal}>
                              <I18N type="ui" path="ADD_PRODUCT" def="Add Product"/>
                            </Button>
                          </Col>
                          {this.state.poTouched && (
                            <Col xs={6} className="text-end">
                              <Button
                                variant="link"
                                onClick={this.handleToggleUndoModal}
                              >
                                <XCircle size={16} className="mb-1 me-1" />
                                <I18N type="ui" path="UNDO_CHANGES" def="Undo Changes"/>
                              </Button>
                            </Col>
                          )}
                        </Row>
                      )}

                      <Row className="mt-4">
                        <Col xs={12}>
                          <div className="overflow-scroll">
                          <Table borderless hover responsive className="table-po text-xs-nowrap">
                            <thead className="bg-primary text-white">
                              <tr>
                                <th><I18N type="ui" path="PRODUCT_CODE" def="貨品編號"/></th>
                                <th>
                                  {/*!this.isReadOnly() && (
                                    <Basket
                                      size={16}
                                      className="mb-1 me-1 d-none d-lg-inline d-xl-inline"
                                    />
                                  )*/}
                                  <I18N type="ui" path="PRODUCT_NAME" def="貨品名稱"/>
                                </th>
                                <th>
                                  {/*!this.isReadOnly() && (
                                    <Calculator
                                      size={16}
                                      className="mb-1 me-1 d-none d-lg-inline d-xl-inline"
                                    />
                                  )*/}
                                  <I18N type="ui" path="PRODUCT_QUANTITY" def="數量"/>
                                </th>
                                <th>
                                  {/*!this.isReadOnly() && (
                                    <Box
                                      size={16}
                                      className="mb-1 me-1 d-none d-lg-inline d-xl-inline"
                                    />
                                  )*/}
                                  <I18N type="ui" path="PRODUCT_PACKAGING_UNIT" def="包裝單位"/>
                                </th>
                                {/*!this.props.weighingList && <th>{!this.isReadOnly() && <Box size={16} className="mb-1 me-1 d-none d-lg-inline d-xl-inline" />}包裝</th>*/}

                                {this.isItemWeigh() && (
                                  <>
                                    <th>
                                      {/*!this.isReadOnly() && (
                                        <BoxSeam
                                          size={16}
                                          className="mb-1 me-1 d-none d-lg-inline d-xl-inline"
                                        />
                                      )*/}
                                      <I18N type="ui" path="INVOICE_WEIGHT" def="抄碼重量"/>
                                    </th>
                                    <th>
                                      {/*!this.isReadOnly() && (
                                        <BoxSeam
                                          size={16}
                                          className="mb-1 me-1 d-none d-lg-inline d-xl-inline"
                                        />
                                      )*/}
                                      <I18N type="ui" path="INVOICE_UNIT" def="抄碼單位"/>
                                    </th>
                                  </>
                                )}

                                {this.isShowPrice() && (
                                <>
                                  <th>
                                  {/*!this.isReadOnly() && (
                                    <Cash
                                      size={16}
                                      className="mb-1 me-1 d-none d-lg-inline d-xl-inline"
                                    />
                                  )*/}
                                      <I18N type="ui" path="PRODUCT_UNIT_PRICE" def="單價"/>
                                  </th>
                                  <th>
                                    {/*!this.isReadOnly() && (
                                      <CashStack
                                        size={16}
                                        className="mb-1 me-1 d-none d-lg-inline d-xl-inline"
                                      />
                                    )*/}
                                    <I18N type="ui" path="TOTAL" def="合計"/>
                                  </th>
                                </>
                                )}
                              </tr>
                            </thead>
                            {this.htmlPurchaseOrderItemList()}
                          </Table>
                          </div>
                        </Col>
                        {this.isShowPrice() && (
                          <Col xs={12} sm={3} className="offset-sm-9">
                            <div className="mt-2 py-2">
                              <div className="text-end font-weight-bold">
                                <span><I18N type="ui" path="SUBTOTAL" def="小計"/>:</span>{" "}
                                {formatCurrency(this.htmlSubTotal())}
                              </div>
                              <hr className="my-2" />
                              <div className="text-end font-weight-bold">
                                <span><I18N type="ui" path="TOTAL" def="合計"/>:</span>{" "}
                                {formatCurrency(this.htmlTotal())}
                              </div>
                            </div>
                          </Col>
                        )}
                      </Row>

                      <Row className="mt-4">
                        <Col xs={12} sm={8}>
                            {
                            !this.state.isEdit
                            ?
                              this.state.data.Remark &&
                              <div>
                                <span className="font-weight-bold text-secondary">
                                <I18N type="ui" path="REMARKS" def="備註"/>:
                                </span>{" "}
                                {this.state.data.Remark}
                              </div>
                            :
                            <div>
                              <Form.Label htmlFor="inputRemark"><I18N type="ui" path="REMARKS" def="備註"/></Form.Label>:
                              <Form.Control
                                type="text"
                                id="inputRemark"
                                onChange={(e) => this.handleOnChangeRemark(e.target.value)}
                                value={this.state.data.Remark ? this.state.data.Remark : ""}
                              />
                            </div>
                            }
                        </Col>
                      </Row>

                      {/* Footer */}
                      <Row>
                        <div className="d-flex mt-5 align-items-end">
                          <div className="d-flex align-items-end">
                            <div id="logo-horus">
                              <img
                                src="/assets/images/logo_horus.png"
                                width="80"
                                alt=""
                              ></img>
                            </div>
                            <div className="powered-by mt-5 ms-4">
                              <I18N type="ui" path="HORUS_TAGLINE" def="此採購單由Horus提供技術支援"/>
                            </div>
                          </div>
                          {/*
                          <div className="ms-auto align-items-end text-end">
                            <div className="d-flex flex-row-reverse align-items-end">
                              <div id="qr-code">
                              <img
                                src="/assets/images/qr-code.svg"
                                width="80"
                                alt=""
                              ></img>
                              <QRCode value={`${process.env.REACT_APP_URL}`+this.props.history.location.pathname} size="80" fgColor="#28b46e"/>
                              </div>
                              <div className="qr-details me-4">
                                <I18N type="ui" path="SCAN_QR_CODE_1" def="閣下可掃描二維碼"/>
                                <br />
                                <I18N type="ui" path="SCAN_QR_CODE_2" def="瀏覽此採購單詳情"/>
                              </div>
                            </div>
                          </div>
                          */}
                        </div>
                      </Row>

                      {(!this.isReadOnly() || this.props.weighingList) && (
                        <Row className="mb-4 no-print">
                          <Col xs={12} sm={6}>
                                <div className="mt-4">
                                  <Can I="zero" a="PurchaseOrderItem" passThrough>
                                    {allowed => <Button
                                      //block={!this.state.isDesktop}
                                      id="btnSavePurchaseOrder"
                                      variant="warning"
                                      onClick={this.handleClickSavePurchaseOrder}
                                      disabled={!allowed ? this.state.dataUI.purchaseOrderItemList.some((item) => item.Num === 0) : false}
                                    >
                                      {this.props.weighingList ? <I18N type="ui" path="SAVE_WEIGHING_LIST" def="Save Weighing List" /> : <I18N type="ui" path="SAVE_PURCHASE_ORDER" def="Save Purchase Order" />}
                                    </Button>}
                                  </Can>
                                </div>
                          </Col>
                          {!this.isReadOnly() && !this.state.isEdit && (
                            <Col
                              xs={12}
                              sm={6}
                              className="mt-4 mb-4 text-sm-end"
                            >
                              <div>
                                <Button
                                  //block={!this.state.isDesktop}
                                  id="btnConfirmPurchaseOrder"
                                  variant="success"
                                  disabled={
                                    this.state.isSavePurchaseOrder
                                      ? true
                                      : false
                                  }
                                  onClick={this.handleClickConfirmPurchaseOrder}
                                >
                                  <I18N type="ui" path="CONFIRM_PURCHASE_ORDER" def="Confirm Purchase Order"/>
                                </Button>
                              </div>
                            </Col>
                          )}

                          {this.state.isEdit && (
                            <Col xs={12} sm={6} className="text-sm-end">
                              <div className="mt-4">
                                <Can I="reject" a="PurchaseOrder">
                                  <Button
                                    //block={!this.state.isDesktop}
                                    id="btnRejectPurchaseOrder"
                                    variant="danger"
                                    disabled={
                                      this.state.isSavePurchaseOrder
                                        ? true
                                        : false
                                    }
                                    onClick={this.handleClickRejectPurchaseOrder}
                                  >
                                    <I18N type="ui" path="REJECT_PURCHASE_ORDER" def="Reject Purchase Order"/>
                                  </Button>
                                </Can>
                              </div>
                            </Col>
                          )}
                        </Row>
                      )}
                      {!this.isReadOnly() && this.htmlAddProduct()}
                      {this.htmlEmail()}
                      {(!this.isReadOnly() ||
                        this.props.weighingList === true) &&
                        this.htmlAlertModal()}
                      {!this.isReadOnly() && this.htmlUndoChanges()}
                    </>
                  )}
              </>
            )}
          </Container>
        </Container>
        <FooterComponent />
        {this.state.isLogs && (
          <LogsModalComponent
            isLogs={this.state.isLogs}
            poId={this.state.data.POId}
            handleClickLogs={this.handleClickLogs}
          />
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const { auth } = state;
  return { auth: auth };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(PurchaseOrder));
